import React from 'react';
import styles from '../search.page.module.scss';
import { Button } from 'src/components/design-system';
import { EVENTS, SEARCH_TYPE } from 'shared/constants';
import { useSelector } from 'react-redux';
import { isImprovedSearchEnabled } from 'shared/store/selectors/features.selector';
import analyticsService from 'src/helpers/analytics.service';
import searchContextIdManager from 'shared/helpers/src/search-context-id-manager';
import { getLang } from 'shared/store/selectors/lang.selector';

const SearchImprovedResults = ({
  regularResultsCount,
  totalRegularResultsCount,
  extendedSearch,
  renderByType,
  sectionContext,
}) => {
  const [showExtendedResults, setShowExtendedResults] = React.useState(false);
  const isImprovedSearch = useSelector(isImprovedSearchEnabled);
  const langScreen = useSelector(getLang('SEARCH_SCREEN'));
  const searchSessionId = useSelector(state => state.search.sessionId);
  const term = useSelector(state => state.search.term);

  // Killer switch - if improved search is disabled
  if (!isImprovedSearch) return null;

  // prepare of extended results
  const {
    resultsCount,
    knowledgeItems = [],
    labItems = [],
    admissionItems = [],
    contactItems = [],
    knowledgeCategories = [],
    labCategories = [],
    admissionCategories = [],
  } = extendedSearch;

  // No results to display
  if (resultsCount === 0) return null;

  // Merge all results and sort by score ASC
  const allResults = [
    ...knowledgeItems,
    ...labItems,
    ...admissionItems,
    ...contactItems,
    ...knowledgeCategories,
    ...labCategories,
    ...admissionCategories,
  ].sort(({ score: a }, { score: b }) => a - b);

  const showExtendedResultsAction = (extendedResultsCount = 0) => {
    setShowExtendedResults(true);
    const eventDetails = {
      term,
      searchSessionId,
      contextId: searchContextIdManager.getContextId(),
      resultsCount,
      extendedResultsCount,
    };

    analyticsService.track(EVENTS.SEARCH.SHOW_MORE, eventDetails);
  };

  // If there are no exact matches, automatically show extended results
  const shouldShowExtendedResults =
    showExtendedResults || totalRegularResultsCount === 0 || regularResultsCount === 0;

  if (!shouldShowExtendedResults) {
    return (
      <div className={styles.extendedResults}>
        <Button type="link" onClick={() => showExtendedResultsAction(resultsCount)}>
          {langScreen.SHOW_ADDITIONAL_RESULTS.replace('{number}', resultsCount)}
        </Button>
      </div>
    );
  }

  // Show results
  return (
    <>
      {allResults.map(({ type, item }, index) => {
        const itemOptions = {
          searchType: SEARCH_TYPE.EXTENDED,
          extendedResultsCount: resultsCount,
          section: sectionContext?.section || '',
          sectionType:
            sectionContext?.sectionType || (type === 'contacts' ? 'contacts' : 'workspace'),
          sectionPosition: sectionContext?.sectionPosition || 0,
          sectionCollapsed: !!sectionContext?.sectionCollapsed,
          position: (sectionContext?.positionOffset || 0) + index + 1,
        };
        return (
          <React.Fragment key={`${type}-${item.id || item._id || index}`}>
            {renderByType[type]({ item }, index, itemOptions)}
          </React.Fragment>
        );
      })}
    </>
  );
};

export { SearchImprovedResults };
